import * as z from 'zod';

export const AddCategorySchema = z.object({
  categoryName: z
    .string()
    .min(3, 'Min 3 characters required')
    .max(40, 'Max 40 characters allowed')
    .regex(/^[a-zA-Z\s'-]+$/, 'Invalid characters used')
    .trim()
    .refine(val => val.length > 0, {
      message: 'Name cannot be just whitespace',
    }),
  description: z.string().min(3, 'Min 3 characters required'),
  imageUrl: z.string().optional(),
  status: z.boolean().optional(),
  id: z.number().optional(),
  isSubCategory: z.boolean().default(false),
  mainCategory: z.string().optional(),
});

export type AddCategorySchemaT = z.infer<typeof AddCategorySchema>;
